/**
 * Résout un chemin interne depuis `MetricObj.Url` (route relative ou URL legacy PrePeers / local).
 * @param {string | undefined} raw Valeur `Url` optionnelle depuis l'API.
 * @returns {string | null} Chemin commençant par `/` si autorisé, sinon `null`.
 */
export function resolveMetricLinkPath(raw: string | undefined): string | null {
  const s = raw?.trim()
  if (!s) return null
  if (s.startsWith('/') && !s.startsWith('//')) return s
  try {
    const parsed = new URL(s)
    const path = `${parsed.pathname}${parsed.search}${parsed.hash}`
    if (!path.replace(/[#?]+$/, '').replace(/\//g, '')) return null
    const host = parsed.hostname.replace(/^www\./, '')
    const isPrePeers = host.endsWith('prepeers.co')
    const isLocal = host === 'localhost' || host === '127.0.0.1'
    if (!isPrePeers && !isLocal) return null
    return path
  } catch {
    return null
  }
}
